import type { ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

export interface FilterBarProps {
  /** Los controles que filtran la lista. */
  children: ReactNode;
  /** Acciones a la derecha (limpiar filtros, exportar…). */
  actions?: ReactNode;
  className?: string;
}

/**
 * La barra de filtros de una lista.
 *
 * Es `<search>` (rol `search`) y no un `<div>`: quien navega por
 * regiones puede saltar directo a "buscar" en vez de tabular por toda la
 * tabla. Candidata a `shared/ui/` — no sabe qué se filtra.
 *
 * `items-end` y no `items-center`: los controles traen label arriba y
 * altura distinta; alinear por la base los deja con la línea de texto a
 * la misma altura, que es lo que se lee como "alineado".
 */
export function FilterBar({ children, actions, className }: FilterBarProps) {
  return (
    <search
      className={cn(
        "flex flex-wrap items-end gap-3 border-b border-ds-border px-4 py-4",
        className,
      )}
    >
      {children}
      {actions && <div className="ml-auto flex items-end gap-2">{actions}</div>}
    </search>
  );
}
